(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/error/request-payment-error.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/error/request-payment-error.js');
'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const _svs$components$payme = svs.components.payment.common.error.constants,
  ClientErrorMessages = _svs$components$payme.ClientErrorMessages,
  ClientErrorCodes = _svs$components$payme.ClientErrorCodes;
const getClientCode = svs.components.payment.common.error.utils.getClientCode;
const PaymentError = svs.components.payment.common.error.PaymentError;

class RequestPaymentError extends PaymentError {
  constructor(_ref) {
    var _ClientErrorMessages$;
    let _ref$clientCode = _ref.clientCode,
      clientCode = _ref$clientCode === void 0 ? ClientErrorCodes.GENERIC_ERROR : _ref$clientCode,
      code = _ref.code,
      extraData = _ref.extraData;
    const clientError = getClientCode(code);
    if (clientError.clientCode) {
      clientCode = clientError.clientCode;
    }
    const message = (_ClientErrorMessages$ = ClientErrorMessages[clientCode]) !== null && _ClientErrorMessages$ !== void 0 ? _ClientErrorMessages$ : "Generic error, errorCode: ".concat(code);
    super({
      clientCode,
      code,
      extraData,
      message
    });
    this.name = 'RequestPaymentError';
  }
  get severity() {
    if (this.clientCode === ClientErrorCodes.BAD_BET) {
      return 'warn';
    }
    return super.severity;
  }
}
_defineProperty(RequestPaymentError, "ClientErrorCodes", ClientErrorCodes);
setGlobal('svs.components.payment.common.error.RequestPaymentError', RequestPaymentError);

 })(window);